import { IValidator } from "../interfaces/IValidator";

// eslint-disable-next-line max-len
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line

export const validators: IValidator[] = [
  {
    name: "longer-than-2",
    validate: (item: string): boolean => item.toString().length > 1,
  },
  {
    name: "email",
    validate: (item: string): boolean => emailRegex.test(item.toString()),
  },
  {
    name: "required",
    validate: (item: boolean): boolean => item,
  },
];
